import { Get, Put, Delete } from ".";

const apiUrl = process.env.VUE_APP_API_FE_STORAGE_URL;

export const Save = async (key,body) => {
    return Put(`${apiUrl}/storage/${key}`, body);
}

export const Detail = async (key) => {
    return Get(`${apiUrl}/storage/${key}`)
}

export const Remove = async (key) => {
    return Delete(`${apiUrl}/storage/${key}`);
};